import React, { useEffect, useRef, useState } from "react";
import fiataLogo from "./assets/aboutus/fiata.png";
import imoLogo from "./assets/aboutus/imo.png";
import ciffaLogo from "./assets/aboutus/CIFFA.png";

const CertGridSection = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect(); // prevent re-trigger
        }
      },
      { threshold: 0.4 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="px-6 lg:px-12 pb-10 overflow-hidden relative"
      
    >
      <style>{`
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-80px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(80px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes popIn {
          0% { opacity: 0; transform: scale(0.7); }
          100% { opacity: 1; transform: scale(1); }
        }
        .animate-left {
          opacity: 0;
          animation: slideInLeft 0.8s ease-out forwards;
        }
        .animate-right {
          opacity: 0;
          animation: slideInRight 0.8s ease-out forwards;
        }
        .pop-in {
          opacity: 0;
          animation: popIn 0.5s ease-out forwards;
        }
      `}</style>

      <div className="flex flex-col lg:flex-row items-stretch justify-between w-full">
        {/* Left Box */}
        <div
          className={`bg-[#00C2FF] text-white w-full lg:w-1/2 py-16 px-6 md:px-10 rounded-[40px] min-h-[420px] flex flex-col items-center justify-center shadow-[0_20px_50px_rgba(0,0,0,0.25)] ${
            visible ? "animate-left" : ""
          }`}
          style={{ animationDelay: "0s", animationFillMode: "forwards" }}
        >
          <div className="max-w-[400px] text-center">
            <h3 className="text-[30px] md:text-[35px] font-bold mb-4">
              That cross continents
            </h3>
            <p className="text-base md:text-xl leading-relaxed">
              and sky blue solutions that link it all together, our network runs wide and deep.
              Whether it’s air, ocean or inland freight, we deliver end-to-end services backed
              by smart warehousing and seamless customs clearance.
            </p>
          </div>
        </div>

        {/* Center Buttons Column */}
        <div className="hidden lg:flex flex-col items-center justify-center gap-5 px-6 w-[450px] shrink-0">
          {[
            "This is Big Blue.",
            "This is logistics in color",
            "This is movement made simple.",
          ].map((text, index) => (
            <div
              key={index}
              className={`text-white text-base font-bold py-3 px-8 rounded-full shadow-[0_6px_18px_rgba(0,0,0,0.15)] ${
                visible ? "pop-in" : "opacity-0"
              }`}
              style={{
                backgroundColor:
                  index === 0
                    ? "#002D6E"
                    : index === 1
                    ? "#00C2FF"
                    : "#3C3C3C",
                animationDelay: `${0.9 + index * 0.2}s`,
                animationFillMode: "forwards",
              }}
            >
              {text}
            </div>
          ))}
        </div>

        {/* Right Box */}
        <div
          className={`bg-[#002D6E] text-white w-full lg:w-1/2 py-16 px-6 md:px-10 rounded-[40px] min-h-[420px] flex flex-col items-center justify-center shadow-[0_20px_50px_rgba(0,0,0,0.25)] ${
            visible ? "animate-right" : ""
          }`}
          style={{ animationDelay: "0s", animationFillMode: "forwards" }}
        >
          <div className="max-w-[320px] text-center">
            <div className="flex items-center justify-center gap-6 mb-6 flex-wrap">
              <img src={fiataLogo} alt="FIATA" className="h-[100px] md:h-[120px]" />
              <img src={imoLogo} alt="IMO" className="h-[100px] md:h-[120px]" />
            </div>
            <p className="text-base md:text-lg leading-relaxed mb-4">
              <strong>FIATA and IMO</strong> certified, Big Blue Inc. is built for businesses that
              demand more. More clarity, more care and more control.
            </p>
            <img src={ciffaLogo} alt="CIFFA" className="h-8 md:h-10 mx-auto" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertGridSection;
